/**
 *
 * @param {TimelineMapProps | StepProps | PropertyValueProps} step
 * @param {String} hook
 */
const getReference = (step, hook) => {
  const options = step.get("options");
  const value = options.get(
    /**@type {keyof PropertyValueObjectProps} */ (hook)
  );

  return value.get("v_value");
};

export default getReference;
